export default {
    cz: {
        sortBy: 'Řadit podle:',
        default: 'Doporučujeme',
        priceLow: 'Nejnižší ceny',
        priceHigh: 'Nejvyšší ceny',
    },
    sk: {
        sortBy: 'Zoradiť podľa:',
        default: 'Odporúčame',
        priceLow: 'Najnižšej ceny',
        priceHigh: 'Najvyššej ceny',
    },
}
